import { ICustomFieldViewModel, CustomFieldType, CustomFieldEditModel } from '../../webgiving-generated';
import { createRulesFromMetadata } from '../../validation/validation-rules';
import { getCustomFieldPropertyMetadata } from '../../utils/customFieldsValidation';
import { FormField } from '../form-field';

export interface ReferenceFieldsViewModel {
	[key: string]: any;
}

export class ReferenceFieldsViewModel {

	defaultFund: FormField<string> | null = null;

	updateDefaultFundValue(fund: string) {
		if (this.defaultFund) {
			this.defaultFund.value = fund;
		}
	}

	updateSingleFundValue(key: string, fundValue: string) {
		if (this[key]) {
			this[key].updateValue(fundValue);
		}
	}

	constructor(public customFields: ICustomFieldViewModel[], currentValues?: CustomFieldEditModel[]) {
		this.customFields.forEach((field) => {
			const fieldMetadata = getCustomFieldPropertyMetadata(field)
			const fieldValidationRules = createRulesFromMetadata(fieldMetadata);
			const currentValue = currentValues ? currentValues.filter(x => x.Key === field.Key)[0] : undefined;
			let value = '';

			if (currentValue && currentValue.Value) {
				value = currentValue.Value;
			} else if ((field.Type === CustomFieldType.Fund || field.Type === CustomFieldType.DropDown) && field.DefaultOptionValue) {
				value = field.DefaultOptionValue;
			}

			this[field.Key] = new FormField<string>(value, fieldValidationRules, fieldMetadata.translationParams);

			if (field.Type === CustomFieldType.Fund) {
				this.defaultFund = this[field.Key];
			}
		});
	}
}
